import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const wasteQuantityField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Waste quantity',
    context: 'The weight of the waste material.',
  }),
  externalDescription: msg({
    message: 'The weight of the waste material.',
    context: 'Waste quantity',
  }),
};

export const wasteTreatmentField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Waste treatment',
    context: 'The display name for the waste treatment field',
  }),
};

export const wasteFields = {
  is_waste_hazardous: {
    displayName: msg({
      message: 'Waste is hazardous',
      context: 'The display name for the waste is hazardous field',
    }),
  },
  is_waste_radioactive: {
    displayName: msg({
      message: 'Waste is radioactive',
      context: 'The display name for the waste is radioactive field',
    }),
  },
  waste_lifecycle: {
    displayName: msg({
      message: 'Waste lifecycle',
      context: 'The display name for the waste lifecycle field',
    }),
  },
  waste_material: {
    displayName: msg({
      message: 'Waste material',
      context: 'The display name for the waste material field',
    }),
  },
  waste_treatment: wasteTreatmentField,
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
